import {
  DefinitionsFromApi,
  OverrideResultType,
  TagTypesFromApi
} from '@reduxjs/toolkit/query'
import { generatedApi } from 'app/services/api/generatedApi'
import { IApiSuccessWrapper } from '$/types'

// RTK#3506
type TagTypes = TagTypesFromApi<typeof generatedApi>
type Definitions = DefinitionsFromApi<typeof generatedApi>
type UpdatedDefinitions = Omit<Definitions, 'getApiUsersGetCurrentUserId'> & {
  getApiUsersGetCurrentUserId: OverrideResultType<
    Definitions['getApiUsersGetCurrentUserId'],
    string
  >
}

export const usersApi = generatedApi.enhanceEndpoints<
  TagTypes,
  UpdatedDefinitions
>({
  endpoints: {
    getApiUsersGetCurrentUserId: {
      transformResponse: (res: IApiSuccessWrapper<string>) => {
        return res.result
      }
    }
  }
})

export const { useGetApiUsersGetCurrentUserIdQuery: useGetCurrentUserIdQuery } =
  usersApi
